import "@aws-amplify/ui-react/styles.css";
import {
  withAuthenticator,
  Button,
  Heading,
  Image,
  View,
  Text,
  TextField,
  Card,
  Flex,
  Message,
} from "@aws-amplify/ui-react";
import { useContext } from "react";
import { GlobalContext } from "../context/global";
import { INutritionData } from "../interfaces";
import { APadded, NextBackButtonHolder } from "../components/layout";
import { AH2 } from "../components/text";
import { Products } from "../components/products";
import { useNavigate } from "react-router";
import { CalorieBar } from "../components/calorieBar"
import styled from "styled-components";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Navigate } from "react-router-dom";

const foo = (x : number) => {}

const TopTextHolder = styled(View)`
  margin-top:10px;
`

const SmallText = styled(Text)`
font-size:smaller;
opacity:0.5;`

const SmallishText = styled(View)`
font-size:15px;
opacity:0.8;`

const BigNumber = styled(Text)`
font-size:20px;
font-weight:bold;
`

const SmallNumber = styled(Text)`
font-size:16px;
font-weight:bold;
`

const NumbersTitle = styled(View)`
  border-bottom: 1px solid #CCC;
  padding:3px 13px;
`

const NumbersHolder = styled(View)`
max-width:6340px;
margin-top:10px;
display: flex;
flex-direction:row;
`

const NumbersRow = styled(View)`
  border: 1px solid #CCC;
  border-radius:15px;
  margin-bottom:4px;
  margin-right:10px;
  flex-direction:column;
  display:flex;
  justify-content:space-between;
  align-items:center;
`

const Spacer = styled(View)`
margin-top:7px;
`
const Question = styled(View)`
  background-color:#EEE;
  display:inline-block;
  width:20px;
  height:18px;
  font-size:12px;
  text-align:center;
  border-radius:10px;
`

// below has max width so that tooltip appears over it.
const ToolTipText = styled(View)`
  max-width:310px;
`


export const ViewEventBasketCalories = () => {
    const navigate = useNavigate();
    const {nutritionData, setNutritionData, addBar, addDrink, addGel, basket} = useContext(GlobalContext);
    
    const haveBasket = (nutritionData as any).hasLoaded
    if (!haveBasket) {
      return <Navigate to="/" />
    }

    const nutrition = nutritionData as INutritionData
    const caloriesInBasket = basket.bars * (nutrition.products.bar?.kcal || 0) + basket.gels * (nutrition.products.gel?.kcal || 0) + basket.drinks * (nutrition.products.drink?.kcal || 0);


    const goBack = () => {
      navigate("/event/new")
    }
    const goToNext = () => {
      navigate("/event/new/1/basket/salt")
    }

    const productData = [{
      numInBasket: basket.gels,
      info: nutrition.products.gel,
      addFunc: addGel
    },{
      numInBasket: basket.drinks,
      info: nutrition.products.drink,
      addFunc: addDrink
    },{
      numInBasket: basket.bars,
      info: nutrition.products.bar,
      addFunc: addBar
    }]

    const Tooltip = <ReactTooltip
      id="my-tooltip-1"
      place="top"
      content="This is the minimum you should consume"
    />
    const x = 2 + 8
    let viewType = "text"; // fancy
    if (x == 9) {
      viewType = "fancy";
    }
    let tipText = "You need to add some more fuel"
    if (nutrition.depletion.depletionZone && (caloriesInBasket > nutrition.depletion.depletionZone)) {
      tipText = "You are out of the depletion zone"
    }

    let messageTheme = "success"
    if (nutrition.depletion.depletionZone && (caloriesInBasket <= nutrition.depletion.depletionZone)) {
      messageTheme = "info"
    }

    // add data-tooltip-id=""
    return <APadded>
      {Tooltip}
      <AH2>Choose your mix of fuel.</AH2>
      <Spacer/>
      <Message
        variation="filled"
        colorTheme={messageTheme as any}
        isDismissible={false}
        heading="">
        Use the buttons below to add items to your fuel mix<br/>
        <b>{tipText}</b>
        </Message>
      { viewType == "text" ? <TopTextHolder>
      <View>
        <Text>Total Calories required: {nutrition.depletion.calories}kcal</Text>
      </View>
      {  nutrition.depletion.depletionZone ? <ToolTipText>
        <SmallishText data-tooltip-id="my-tooltip-1">Depletion zone: {nutrition.depletion.depletionZone}kcal <Question>?</Question></SmallishText>
      </ToolTipText> : null }
      <View>
        <Text>Calories in your pack: {caloriesInBasket}kcal</Text>
      </View>
      </TopTextHolder> : null }
      { viewType == "fancy" ? <NumbersHolder>
        { /* <NumbersRow><Text>Minimum calories required</Text><SmallNumber>2113kcal</SmallNumber></NumbersRow> */ }
        <NumbersRow><NumbersTitle>Calories you will burn</NumbersTitle><BigNumber>{nutrition.depletion.calories}kcal</BigNumber></NumbersRow>
        <NumbersRow><NumbersTitle>Calories in your pack</NumbersTitle><BigNumber>{caloriesInBasket}kcal</BigNumber></NumbersRow>
      </NumbersHolder> : null}
      <View>
        <CalorieBar maxCalories={nutrition.depletion.calories} depletionZoneCalories={nutrition.depletion.depletionZone || 0} currentCalories={caloriesInBasket} />
      </View>
      <Products
        products={productData}
       />
       <NextBackButtonHolder>
       <Button onClick={goBack}>
              ‹ Back 
            </Button>
      <Button onClick={goToNext}>
                Next ›
            </Button>
            </NextBackButtonHolder>
    </APadded>
}